import { REBOTT_URL_WEBSITE, REBOTT_URL_LINE_OA, REBOTT_URL_LINK_PORTAL, REBOTT_URL_MANUAL } from "@/config";
import { Typography} from "@material-tailwind/react";
import { BuildingOffice2Icon, EnvelopeIcon, PhoneIcon, GlobeAltIcon, MapIcon } from "@heroicons/react/24/solid";
import {
  FaFacebookF,
  FaTiktok,
  FaLine,
  FaInstagram,
} from "react-icons/fa";
import Script from "next/script";

const LINKS = [
  {
    title: "ผลิตภัณฑ์",
    items: [
      { name: "Rebott - Smart Reverse Vending", url: REBOTT_URL_WEBSITE, icon: undefined },
      { name: "Rebott Manual", url: REBOTT_URL_MANUAL, icon: undefined },

    ],
  },
  {
    title: "ติดต่อเรา",
    items: [
      { name: "Email", url: "mailto:info@smartmachine.co.th", icon: undefined },
      { name: "Line Official Account", url: REBOTT_URL_LINE_OA, icon: undefined },
      { name: "Link Portal", url: REBOTT_URL_LINK_PORTAL, icon: undefined },

    ],
  },
  {
    title: "โซเชียล",
    items: [
      { name: "Facebook", url: "https://www.facebook.com/people/Rebott-%E0%B9%80%E0%B8%84%E0%B8%A3%E0%B8%B7%E0%B9%88%E0%B8%AD%E0%B8%87%E0%B8%A3%E0%B8%B1%E0%B8%9A%E0%B8%84%E0%B8%B7%E0%B8%99%E0%B8%82%E0%B8%A7%E0%B8%94%E0%B8%99%E0%B9%89%E0%B8%B3/61576335497146/", icon: <FaFacebookF className="size-4 text-[#2998E2]" /> },
      { name: "TikTok", url: "https://www.tiktok.com/@rebott.official", icon: <FaTiktok className="size-4 text-[#2998E2]" /> },
      { name: "Intragram", url: "https://www.instagram.com/rebott.official", icon: <FaInstagram className="size-5 text-[#2998E2]" /> },
      { name: "Line Official Account", url: REBOTT_URL_LINE_OA, icon: <FaLine className="size-5 text-[#2998E2]" /> },
    ],
  },
];


const CURRENT_YEAR = new Date().getFullYear();

export function Footer() {
  return (
  <>
  <footer className="bg-[#F5FCFE] pt-12 pb-20">
    <div className="container mx-auto px-6 lg:px-6">
      <div className="grid grid-cols-1 lg:grid-cols-5 w-full gap-10">

        <div className="col-span-1 lg:col-span-2">
          <Typography  {...({} as any)} variant="h5" className="mb-3 text-left text-[#2998E2] font-extrabold">
            Rebott
          </Typography>

          <div className="flex items-start gap-2 text-[#2998E2]">
            <BuildingOffice2Icon className="size-4 mt-1" />
            <div className="text-sm leading-relaxed space-y-0.5">
              <p>บริษัท สมาร์ท แมชชีน แอนด์ ซอฟต์แวร์ จำกัด</p>
              <p>เลขที่ 1024 อาคารสุพรีมคอมเพล็กซ์</p>
              <p>ห้องเลขที่ L1409/2 ถนนสามเสน</p>
              <p>แขวงถนนนครไชยศรี เขตดุสิต กรุงเทพฯ 10300</p>
            </div>
          </div>

          <div className="mt-6 space-y-2 text-[#2998E2]">
            <div className="flex items-center gap-2">
              <EnvelopeIcon className="size-4" />
              <p className="text-sm mr-6">อีเมล:
                <a
                  href="mailto:info@smartmachine.co.th"
                  className="text-sm underline hover:no-underline ml-1"
                >
                info@smartmachine.co.th
                </a>
              </p>
            </div>
            <div className="flex items-center gap-2">
              <PhoneIcon className="size-4" />
              <p className="text-sm mr-6">เบอร์ติดต่อ:
              <a
                href="tel:02-026-6976"
                className="text-sm underline hover:no-underline ml-1"
              >
                02-026-6976
              </a>
              </p>
            </div>
            <div className="flex items-center gap-2">
              <GlobeAltIcon className="size-5" />
              <p className="text-sm mr-6">เว็บไซต์: <a
                href="https://www.smartmachine.co.th"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-[#2998E2] underline hover:underline"
              >
                https://www.smartmachine.co.th
              </a>
              </p>
            </div>
          </div>
        </div>

        {LINKS.map(({ title, items }) => (
          <div key={title} className="col-span-1 text-[#2998E2]">
            <Typography  {...({} as any)} variant="h6" className="mb-4 text-[#2998E2] font-bold">
              {title}
            </Typography>
            <ul className="space-y-2">
              {items.map(({ name, url, icon }) => (
                <li key={name}>
                  <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-sm hover:underline"
                  >
                    {icon && icon}
                    {name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}

      </div>
    </div>

  </footer>
      <div className="bg-[#2998E2] w-full py-4">
        <div className="mx-auto max-w-5xl px-4">
          <Typography  {...({} as any)}
            color="blue-gray"
            className="text-center font-normal !text-white text-sm "
          >
            COPYRIGHT &copy;{" "}
            <a
              href={REBOTT_URL_WEBSITE}
              target="_blank"
              className="hover:underline text-gray-800"
            >
              Rebott
            </a>{" "}
            2025. ALL RIGHTS RESERVED.
          </Typography>
        </div>
      </div>
  </>
  );
}

export default Footer;
